if (!customElements.get('melaxin-customer-reviews')) {
  customElements.define('melaxin-customer-reviews', class extends HTMLElement {
    connectedCallback() {
      this.initialize();
      if (this.events) return;
      this.setupObserver = new MutationObserver(() => { this.initialize(); if (this.events) this.setupObserver.disconnect(); });
      this.setupObserver.observe(this, { childList: true, subtree: true });
    }

    initialize() {
      if (this.events || !this.querySelector('[data-photo-close]')) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.page = 1;
      this.perPage = Math.max(1, Math.min(20, Number(this.dataset.perPage) || 5));
      this.cards = Array.from(this.querySelectorAll('[data-review]'));
      this.list = this.querySelector('[data-review-list]');
      this.rating = this.querySelector('[data-rating-filter]');
      this.sort = this.querySelector('[data-sort]');
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      this.dialog = this.querySelector('dialog');
      [this.rating, this.sort].forEach(control => control.addEventListener('change', () => { this.page = 1; this.render(); }, options));
      this.previous.addEventListener('click', () => this.changePage(-1), options);
      this.next.addEventListener('click', () => this.changePage(1), options);
      this.addEventListener('click', event => {
        const expand = event.target.closest('[data-expand]');
        if (expand) {
          const expanded = expand.closest('[data-review]').classList.toggle('is-expanded');
          expand.setAttribute('aria-expanded', String(expanded));
          expand.textContent = expanded ? this.dataset.lessLabel : this.dataset.moreLabel;
        }
        const photo = event.target.closest('[data-photo]');
        if (photo) {
          const original = photo.querySelector('img');
          const image = this.dialog.querySelector('img');
          image.src = original.currentSrc || original.src;
          image.alt = original.alt;
          this.dialog.showModal();
        }
      }, options);
      this.querySelector('[data-photo-close]').addEventListener('click', () => this.dialog.close(), options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.cards.findIndex(card => card.dataset.blockId === event.detail?.blockId);
        if (index < 0) {
          if (Array.from(this.querySelectorAll('[data-settings-block]')).some(block => block.dataset.settingsBlock === event.detail?.blockId)) {
            this.scrollIntoView({ block: 'start', behavior: 'instant' });
          }
          return;
        }
        this.rating.value = 'all'; this.sort.value = 'original';
        this.page = Math.floor(index / this.perPage) + 1;
        this.render();
        this.cards[index].scrollIntoView({ block: 'center', behavior: 'instant' });
      }, options);
      this.render();
    }

    disconnectedCallback() { this.events?.abort(); this.events = null; this.setupObserver?.disconnect(); }

    format(text, values) { return text.replace(/\[(\w+)\]/g, (token, key) => values[key] ?? token); }

    changePage(change) {
      this.page += change;
      this.render();
      this.querySelector('.melaxin-reviews__controls').scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      (this.next.disabled ? this.previous : this.next).focus({ preventScroll: true });
    }

    render() {
      const ordered = [...this.cards].sort((a, b) => {
        const difference = Number(b.dataset.rating) - Number(a.dataset.rating);
        return (this.sort.value === 'highest' ? difference : this.sort.value === 'lowest' ? -difference : 0) || Number(a.dataset.index) - Number(b.dataset.index);
      });
      const filtered = ordered.filter(card => this.rating.value === 'all' || card.dataset.rating === this.rating.value);
      const pages = Math.max(1, Math.ceil(filtered.length / this.perPage));
      this.page = Math.max(1, Math.min(this.page, pages));
      const start = (this.page - 1) * this.perPage;
      const visible = new Set(filtered.slice(start, start + this.perPage));
      this.cards.forEach(card => { card.hidden = !visible.has(card); });
      this.list.append(...ordered);
      this.querySelector('[role="status"]').textContent = filtered.length
        ? this.format(this.dataset.countText, { first: start + 1, last: Math.min(start + this.perPage, filtered.length), total: filtered.length })
        : this.dataset.emptyLabel;
      this.querySelector('[data-page]').textContent = this.format(this.dataset.pageText, { page: this.page, pages });
      this.previous.disabled = this.page === 1;
      this.next.disabled = this.page === pages;
      this.querySelector('nav').hidden = pages <= 1;
    }
  });
}
